import { StyleSheet, Image, ScrollView } from 'react-native'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import Button from '@app/sharedComponents/Button/Button'
import ROUTE from '@app/navigationApp/routes'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '@app/navigationApp/types'
import ShieldCheckIcon from '@app/assets/svg/ShieldCheckIcon'
import { useTheme } from '@shopify/restyle'


const NoAccountFound = ({ navigation, handleAddBankAccount }: { navigation: NativeStackNavigationProp<PrivateStackParamList, "BANK_ACCOUNT_VERIFICATION", undefined>, handleAddBankAccount: () => void }) => {

  const { colors } = useTheme<Theme>();
  return (
    <ThemedView flex={1}>
      <ScrollView>
        <ThemedView padding='lg'>
          <Image style={{ width: 64, height: 64, aspectRatio: 1 }} source={{ uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bank_verifying_details.png' }} />
          <ThemedText mt='sm' variant='h5s' fontWeight='600' color='text-primary'>Proceed to add bank account</ThemedText>
          <ThemedText mt='sm' variant='b3r' color='text-secondary'>Add a bank account for disbursal</ThemedText>
        </ThemedView>

      </ScrollView>
      <ThemedView
        style={{ width: "100%" }}
        bg='bg-surface-primary'
        padding='lg'
        borderTopWidth={1}
        borderTopColor='border-primary'
      >
        <ThemedView mb='md' flexDirection='row' justifyContent='center' alignItems='center'>
          <ShieldCheckIcon size={14} />
          <ThemedText textAlign='center' ml='sm' color='text-emphasis-secondary' variant='b4r'>
            Your data is secure with us
          </ThemedText>
        </ThemedView>
        <Button
          label="Add bank account"
          type="SOLID"
          eventName='VERIFY_BANK_ADD_ACCOUNT_BUTTON'
          handlePress={handleAddBankAccount}
          size='MD'
          bg={colors['bg-action-primary']}
          textColor={colors['text-primary']}
        />
      </ThemedView>
    </ThemedView>
  )
}

export default NoAccountFound;
